module.exports = __webpack_public_path__ + "static/media/COMERCIAL FIRMO.58a5b817.png";